// @ts-nocheck

import { type StateType } from '../../../states';
import { type OutcomeState } from '../../../states/entities/outcomes';
import { type EntitiesOutcomes } from '../../../states/entities/outcomes';
import { type OutcomeId } from '../../../states/entities/outcomes';
import { type Selector } from '../../../types/selectors';
import { getOutcomeIdOrOddsIdFromProps } from '../../_propsGetters_';
import { type GetOutcomeIdOrOddsIdFromPropsType } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesOutcomes: Selector<EntitiesOutcomes> = (state: StateType) =>
  selectEntitiesState(state)?.outcomes ?? emptyObject;

export const selectEntitiesOutcomesEntity: Selector<OutcomeState | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => {
  const id = getOutcomeIdOrOddsIdFromProps(state, props);

  if (id) {
    return selectEntitiesOutcomes(state)[id];
  }
};

export const selectEntitiesOutcomesEntityCode: Selector<string | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.code;

export const selectEntitiesOutcomesEntityLabel: Selector<string | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.label;

export const selectEntitiesOutcomesEntityOutcomeId: Selector<OutcomeId | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.outcomeId;

export const selectEntitiesOutcomesEntityOddId: Selector<number | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.oddId;

export const selectEntitiesOutcomesEntityBetId: Selector<number | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.betId;

export const selectEntitiesOutcomesEntityTeam: Selector<1 | 2 | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.team;

export const selectEntitiesOutcomesEntityAvailable: Selector<boolean | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.available ?? false;

export const selectEntitiesOutcomesEntityPercentDistribution: Selector<number | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.percentDistribution;

export const selectEntitiesOutcomesEntityPlayerId: Selector<number | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.playerId;

export const selectEntitiesOutcomesEntitySrPlayerId: Selector<string | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.srPlayerId;

export const selectEntitiesOutcomesEntityHasOccured: Selector<boolean | null> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => {
  const outcomeState = selectEntitiesOutcomesEntity(state, props);
  return outcomeState?.hasOccured ?? null;
};

export const selectEntitiesOutcomesEntityIsCancelled: Selector<boolean | null> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => {
  const outcomeState = selectEntitiesOutcomesEntity(state, props);
  return outcomeState?.isCancelled ?? null;
};

export const selectEntitiesOutcomesEntityFlag: Selector<string | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.flag;

export const selectEntitiesOutcomesEntityVoidReason: Selector<number | null | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.voidReason;

export const selectEntitiesOutcomesEntityIcon: Selector<string | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.icon;

export const selectEntitiesOutcomesEntityHotUsers: Selector<number | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectEntitiesOutcomesEntity(state, props)?.hotUsers;
